import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeMagicLinkSignIn } from '@/lib/auth';

export function AuthCallback() {
  const navigate = useNavigate();
  const [state, setState] = useState<'working' | 'done' | 'error'>('working');
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    completeMagicLinkSignIn()
      .then((user) => {
        if (user) {
          setState('done');
          navigate('/', { replace: true });
        } else {
          setState('error');
          setErr('No pending sign-in found. Try requesting a new magic link.');
        }
      })
      .catch((e: Error) => {
        setState('error');
        setErr(e.message);
      });
  }, [navigate]);

  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="glass mx-auto max-w-md p-8 text-center">
        {state === 'working' && <div className="text-ink-700">Completing sign-in…</div>}
        {state === 'done' && <div className="text-ink-700">Redirecting…</div>}
        {state === 'error' && (
          <div>
            <div className="text-ink-900 font-semibold">Sign-in failed</div>
            <div className="mt-1 text-xs text-ink-600">{err}</div>
          </div>
        )}
      </div>
    </div>
  );
}
